module.exports = __webpack_public_path__ + "img/c8c889e2-92ec-4b91-b72d-dba0e951aeaf.d97151d2.webp";